import styled from 'styled-components';
import theme from '../theme';

export const PageWrapper = styled.div`
  font-family: ${theme.typography.fontFamily};
`;

export const PageHeader = styled.div`
  text-align: center;
  margin-bottom: ${theme.spacing.xl};
`;

export const PageTitle = styled.h1`
  font-size: ${theme.typography.h1.size};
  font-weight: ${theme.typography.h1.weight};
  color: ${theme.colors.text};
  margin: 0 0 ${theme.spacing.sm};

  ${theme.media.mobile} {
    font-size: ${theme.typography.h2.size};
  }
`;

export const PageSubtitle = styled.p`
  font-size: ${theme.typography.body.size};
  color: ${theme.colors.textSecondary};
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
`;

export const ThesisBanner = styled.div`
  background: ${theme.colors.surface};
  border-radius: ${theme.radii.md};
  box-shadow: ${theme.shadows.sm};
  border-left: 4px solid ${theme.colors.primary};
  padding: ${theme.spacing.lg};
  margin-bottom: ${theme.spacing.xl};
`;

export const ThesisKicker = styled.div`
  font-size: ${theme.typography.tiny.size};
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: ${theme.colors.primary};
  margin-bottom: ${theme.spacing.sm};
`;

export const ThesisTitle = styled.h2`
  font-size: ${theme.typography.h2.size};
  font-weight: ${theme.typography.h2.weight};
  color: ${theme.colors.text};
  margin: 0 0 ${theme.spacing.sm};
`;

export const ThesisBody = styled.p`
  font-size: ${theme.typography.body.size};
  color: ${theme.colors.textSecondary};
  line-height: 1.6;
  max-width: 820px;
  margin: 0 0 ${theme.spacing.md};
`;

export const FunnelRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${theme.spacing.sm};
  margin: 0 0 ${theme.spacing.md};
`;

export const FunnelStep = styled.span`
  border-radius: ${theme.radii.full};
  padding: 6px 14px;
  font-size: ${theme.typography.small.size};
  font-weight: 600;
  white-space: nowrap;
  ${({ $variant }) => {
    if ($variant === 'primary') {
      return `background: ${theme.colors.primary}; color: #ffffff;`;
    }
    if ($variant === 'success') {
      return `background: ${theme.colors.successLight}; color: ${theme.colors.success};`;
    }
    return `background: ${theme.colors.primaryGhost}; color: ${theme.colors.primary};`;
  }}
`;

export const FunnelConnector = styled.span`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 0 ${theme.spacing.xs};
`;

export const FunnelArrow = styled.span`
  color: ${theme.colors.textMuted};
  font-size: ${theme.typography.body.size};
  line-height: 1;
`;

export const FunnelCaption = styled.span`
  color: ${theme.colors.textMuted};
  font-size: ${theme.typography.tiny.size};
  font-weight: 500;
  white-space: nowrap;
`;

export const ThesisActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${theme.spacing.md};
`;

export const ThesisCta = styled.button`
  background: ${theme.colors.primary};
  color: #ffffff;
  border: none;
  border-radius: ${theme.radii.sm};
  padding: 10px 20px;
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.small.size};
  font-weight: 600;
  cursor: pointer;
  transition: background ${theme.transitions.fast};

  &:hover {
    background: ${theme.colors.primaryLight};
  }
`;

export const ThesisLink = styled.span`
  color: ${theme.colors.primary};
  font-size: ${theme.typography.small.size};
  font-weight: 600;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const SectionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${theme.spacing.lg};

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const SectionCard = styled.div`
  background: ${theme.colors.surface};
  border-radius: ${theme.radii.md};
  box-shadow: ${theme.shadows.sm};
  padding: ${theme.spacing.lg};
  cursor: pointer;
  transition: all ${theme.transitions.normal};
  border-left: 4px solid ${({ $accent }) => $accent || theme.colors.primary};
  display: flex;
  flex-direction: column;

  &:hover {
    box-shadow: ${theme.shadows.md};
    transform: translateY(-2px);
  }
`;

export const SectionIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: ${theme.radii.sm};
  background: ${({ $bg }) => $bg || theme.colors.primaryGhost};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin-bottom: ${theme.spacing.md};
  flex-shrink: 0;
`;

export const SectionTitle = styled.h3`
  font-size: ${theme.typography.h3.size};
  font-weight: ${theme.typography.h3.weight};
  color: ${theme.colors.text};
  margin: 0 0 ${theme.spacing.sm};
`;

export const SectionDescription = styled.p`
  font-size: ${theme.typography.small.size};
  color: ${theme.colors.textSecondary};
  margin: 0;
  line-height: 1.6;
  flex: 1;
`;

export const SectionArrow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${theme.spacing.xs};
  color: ${theme.colors.primary};
  font-size: ${theme.typography.small.size};
  font-weight: 600;
  margin-top: ${theme.spacing.md};
`;
